import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatMoney = (value) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(value);
    };

// Affiche un numero au format international normalise (ex: +221 77 123 45 67).
// La valeur stockee est en E.164 ; defaultCountry sert de filet pour les
// anciens numeros enregistres sans indicatif.
export const formatPhone = (value, defaultCountry = 'SN') => {
    if (!value) return '';
    const parsed = parsePhoneNumberFromString(String(value), defaultCountry);
    return parsed ? parsed.formatInternational() : value;
};

// Format brut pour l'input (ex: 12 345,67)
export const formatMoneyInput = (value) => {
    if (value === '' || value === null || isNaN(value)) return '';
    return Number(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

